var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"toggle-button",class:{ active: _vm.active },on:{"click":_vm.Toggle}},[_c('div',{staticClass:"icon"})])}
var staticRenderFns = []

export { render, staticRenderFns }